import { FRAGMENT_OWNER } from "@/graphql/fragments";
import gql from "graphql-tag";

export const SUBSCRIPTION_QUOTA = gql`
  subscription quotaUpdated {
    quotaUpdated
  }
`;

export const USAGE_QUOTA = gql`
  query usageQuota {
    organization {
      quotas {
        # The usage type
        quotum_group
        # The used reports/minutes
        usage_used
        # The limit
        usage_quotum
      }
    }
  }
`;

export const MESSAGES = gql`
  query messages {
    messages(orderBy: ID_DESC, last: 100) {
      nodes {
        message
        metadata
        time
        receiverAccountId
        id
        receiverAccount {
          name
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;

export const SUBSCRIPTION_MESSAGE = gql`
  subscription messageReceived {
    messageReceived {
      message {
        message
        receiverAccount {
          ...owner
        }
        metadata
        time
      }
    }
  }

  ${FRAGMENT_OWNER}
`;
